/**
 * An entry in AsyncSearchableSelectField
 */
export default class AsyncSearchableSelectFieldEntry<T> {
  /**
   * Label to display for the option entry in the AsyncSearchableSelectField.
   */
  label: string;

  /**
   * Value of the option entry in the AsyncSearchableSelectField.
   */
  value: string;

  /**
   * The entity.
   */
  entity?: T;

  constructor(label: string, value: string, entity: T) {
    this.label = label;
    this.value = value;
    this.entity = entity;
  }
}
